import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import Swal from "sweetalert2";
import clienteAxios from "../../helpers/clienteAxios";

const apiCompararSim = async ({ numero_linea, ultimos_digitos }) => {

    const numeroFormateado = numero_linea.startsWith("88")
      ? "56" + numero_linea.slice(2)
      : numero_linea;
   
    const { data } = await clienteAxios.post(`/sucursalVirtual/crm/compararSim`, { numero_linea: numeroFormateado, ultimos_digitos });
    return data;
  };  

const useCompararSim = () => {
  const [success, setSuccess] = useState(false);

  const mutation = useMutation(apiCompararSim, {
    onSuccess: (response) => {
     
      setSuccess(response.success);
    },
    onError: (error) => {
      console.error("Error en la consulta", error);
    },
  });

  return { ...mutation, success }; 
};

export default useCompararSim;